import { useMemo } from "react";
import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import { SupabaseCustomEmailService } from "../../../../channels/email/server/supabase-custom-email-service";
import { useMomentFormValues } from "../../../hooks/use-moment-form-values";
import type { MomentRestrictions } from "../../../hooks/use-moment-restrictions";
import { usesRestrictedSegmentOrEmail } from "../uses-restricted-data";

export function usePublishPermissions(momentRestrictions: MomentRestrictions): {
  isRestricted: boolean;
  loading: boolean;
} {
  const {
    segment,
    "email_moment.from_address": emailFrom,
    from: legacyFrom,
  } = useMomentFormValues(["segment", "email_moment.from_address", "from"]);

  const { data: customEmails, loading } = useSupabaseLoader(
    async ({ supabase, abortController }) => {
      const { data, error } = await new SupabaseCustomEmailService(supabase).getAllVerified();
      if (error && !abortController?.signal?.aborted)
        console.error("Error loading custom email addresses", error);
      return data ?? [];
    },
    [],
  );

  const isRestricted = useMemo(() => {
    return usesRestrictedSegmentOrEmail({
      restrictedSegments: momentRestrictions.segment,
      restrictedEmails: momentRestrictions.email_from,
      email_from_address: legacyFrom || emailFrom,
      segment_id: segment?.id ?? null,
      customEmailAddresses: customEmails ?? [],
    });
  }, [momentRestrictions, legacyFrom, emailFrom, segment?.id, customEmails]);

  return { isRestricted, loading };
}
